import raData, { grades, locations } from '../components/raPruefung';
import ra, { RALocation } from '../components/RA';
import raa, { RAALocation } from '../components/RAA';
import jobData from '../components/berufstraegerInnen';
import _ from 'lodash';

export const getGrades = () => {

    var finalGrades = [];
    Object.keys(grades).forEach((key) => {
        finalGrades.push(grades[key])
    })
    return finalGrades;
}

export const getYears = () => {
    var years = [];

    raData.forEach((data) => {
        var currentYear = data.year;

        if (years.indexOf(currentYear) === -1) {
            years.push(currentYear);
        }
    });

    return years;
}

export const actualYears = () =>{
    var years = [];

    raData.forEach((data) => {
        if(data.RA) {
            var currentYear = data.year;
        
            if (years.indexOf(currentYear) === -1) {
                years.push(currentYear);
            }
        }

    });

    return years;
}

export const groupByCityAndYears = (years) => {
    var groups = _.groupBy(raData, "location");

    var final = {};

    Object.keys(groups).forEach((key) => {
        final[key] = {};

        years.forEach((year) => {
            groups[key].forEach((yearData) => {
                if (yearData.year === year) {
                    final[key][year] = yearData.data;
                }
            });
        });
    });

    return final;

}

export const groupByCityAndYearsRA = (years) => {
    var groups = _.groupBy(raData, "location");

    var final = {};

    Object.keys(groups).forEach((key) => {
        final[key] = {};

        years.forEach((year) => {
            groups[key].forEach((yearData) => {
                if (yearData.year === year) {
                    final[key][year] = yearData.RA;
                }
            });
        });
    });

    return final;

}

export const groupByCityAndYearsRAA = (years) => {
    var groups = _.groupBy(raData, "location");

    var final = {};

    Object.keys(groups).forEach((key) => {
        final[key] = {};

        years.forEach((year) => {
            groups[key].forEach((yearData) => {
                if (yearData.year === year) {
                    final[key][year] = yearData.RAA;
                }
            });
        });
    });

    return final;

}


export const getTotalPerYear = (years, cityAndYearGroups) => {
    var yearSums = {};

    years.forEach((year) => {
        yearSums[year] = [0, 0, 0, 0];
    });

    Object.keys(cityAndYearGroups).forEach((city) => {

        Object.keys(cityAndYearGroups[city]).forEach((year) => {

            for (var i = 0; i < 4; i++) {
                yearSums[year][i] += cityAndYearGroups[city][year][i];
            }

        });

    });

    return yearSums;
}

export const getYearPercentagesByGradeIndex = (gradeIndex, cityAndYearGroups) => {
    var finalArray = {};

    Object.keys(cityAndYearGroups).forEach((city) => {

        finalArray[city] = [];

        Object.keys(cityAndYearGroups[city]).forEach((year) => {

            var gradeSum = 0;

            cityAndYearGroups[city][year].forEach((gradeValue) => {
                gradeSum += gradeValue;
            });

            var percent = cityAndYearGroups[city][year][gradeIndex] / gradeSum * 100;

            finalArray[city].push(Math.round(percent));
        });

    });

    return finalArray;
}

export const getPercentOfCityEachGrade = (cities, citySum) => {
    var grazPercent = [];
    var prozent;
    Object.keys(cities).forEach((data) => {
        prozent = cities[data] / citySum * 100;
        grazPercent.push(Math.round(prozent));

    });
    return grazPercent
}

export const getListOfNumbersPerGradeOfAllYearsAllLocations = (cityAndYearGroups) => {
    var citySums = {};

    Object.keys(cityAndYearGroups).forEach((city) => {
        const sum = [0, 0, 0, 0];

        Object.keys(cityAndYearGroups[city]).forEach((year) => {
            Object.keys(cityAndYearGroups[city][year]).forEach((grade) => {
                sum[grade] += cityAndYearGroups[city][year][grade]
            });
        });

        citySums[city] = sum;
    });

    return citySums;

}

export const getLocationObjectWithXandY = (listOfSelectedYears, gradeIndex) => {
    var locationObject = {};
    // {
    //     "Graz": [ { x: 2010, y: 1 } ... ],
    //     "Innsbruck": [ { x: 2010, y: 1 } ],
    // }
    Object.keys(listOfSelectedYears).forEach((location) => {
        locationObject[location] = [];

        Object.keys(listOfSelectedYears[location]).forEach((year) => {
            var sum = listOfSelectedYears[location][year].reduce((total, item) => {
                return total + item
            });

            var gradeCount = listOfSelectedYears[location][year][gradeIndex];

            var gradePercent = Math.round(gradeCount / sum * 100);

            locationObject[location].push({ x: year, y: gradePercent })
        });
    });
    return locationObject;
}

export const getSumOfAllGradesPerYearPerLocation = (groupByCityAndYears) => {
    var finalArray = [];
    Object.keys(groupByCityAndYears).forEach((location) => {
        var locationArray = [];
        Object.keys(groupByCityAndYears[location]).forEach((year) => {
            var summe = (groupByCityAndYears[location][year].reduce((total, item) => {
                return total + item
            })
            ); locationArray.push(summe);
        }); finalArray.push(locationArray)
    });
    return finalArray
}

export const getSumOfAllPerLocationForSelectedYears = (final) => {

    var finalArray = [];

    Object.keys(final).forEach((location) => {

        var sum = 0;
        var array = [];
        Object.keys(final[location]).forEach((year) => {

            var summe = 0;
            summe = final[location][year].reduce((total, item) => {
                return total + item
            });
            array.push(summe);
        });
        sum = _.reduce(array, function (total, n) {
            return total + n;
        }, 0);
        finalArray.push(sum);
// console.log(finalArray)
    });
    return finalArray
}

export const getSumOfAllPerLocationForSelectedYearsRA = (final) => {
    console.log(final)
    var finalArray = [];
    var array = {};
    
    Object.keys(final).forEach((location) => {
        var sum = 0;
        // array[location] = [];
        Object.keys(final[location]).forEach((year) => {

            if (final[location][year] != null){
                sum += final[location][year];
            }
        })
        
        finalArray.push(sum);
    });

    console.log(finalArray);

    return finalArray
}

export const getLocationCapital = () => {
    var capital = [];
    var raCapital = _.map(ra, 'Hauptstadt');
    var raaCapital = _.map(raa, 'Hauptstadt');

    for (var i = 0; i < raCapital.length; i++) {
        capital.push({ x: RALocation[i], y: (raCapital[i] / raaCapital[i]).toFixed(2) })
    }

    return capital
}

export const getLocationLand = () => {
    var land = [];
    var raLand = _.map(ra, 'Land');
    var raaLand = _.map(raa, 'Land');

    for (var i = 0; i < raLand.length; i++) {
        land.push({ x: RALocation[i], y: (raLand[i] / raaLand[i]).toFixed(2) })
    }
    return land
}


export const getComparisonPerYear = () => {
    var final = {};
    var step = [];
    var groups = _.groupBy(jobData, 'year')

    Object.keys(groups).forEach((year) => {
        final[year] = [];
        step = []
        Object.keys(groups[year]).forEach((loc) => {
            step.push({ x: (groups[year][loc].location), y: (groups[year][loc].raa) })
        })
        final[year].push(step)
    })

    return final

}

export const getComparisonRAAperRA = () => {
    var final = {};
    var step = [];
    var groups = _.groupBy(jobData, 'year')

    Object.keys(groups).forEach((year) => {
        final[year] = [];
        step = []
        Object.keys(groups[year]).forEach((loc) => {

            var sum = (groups[year][loc].raa / groups[year][loc].ra).toFixed(2)
            step.push({ x: (groups[year][loc].location), y: sum })
        })
        final[year].push(step)
    })

    return final

}


export const getAustria = (listOfGradeNumbers) => {

    console.log(listOfGradeNumbers)

}


/* Chart Options */
export const getRapPerYearBarChart = (years, grade) => {
    return {
        chart: {
            fontFamily: "'Open Sans', sans-serif",
            toolbar: {
                tools: {
                    download: false
                }
            }
        },
        xaxis: {
            categories: years,

            axisBorder: {
                show: false
            },
        },
        yaxis: {
            show: true,
            formatter: (val) => {
                return `${val}%`
            },
        },

        // colors: ['#025171', '#036186', '#046E98', '#84A0B7', '#E73729'],
colors: ['#558ed5', '#93cddd', '#c3d69b', '#fac090', '#d99694'],
        tooltip: {
            shared: true,
            y: {
                formatter: (val) => {
                    return `${val}%`
                }
            },
            intersect: false
        },

        dataLabels: {
            enabled: false
        },
        markers: {
            size: [0, 0, 0, 0, 5]
        },
        plotOptions: {
            bar: {
                horizontal: false,
                dataLabels: {
                    position: 'top',
                    orientation: 'vertical',
                },
                columnWidth: "40%"
            }
        },
        title: {
            text: `Mit "${Object.values(grades)[grade].title}" beurteilte RAP im Zeitraum ${years[0]} - ${years[years.length - 1]} (Vergleich)`,
            align: 'left',
            margin: 20,
            offsetY: 20,
            style: {
                fontSize: '25px'
            }
        },
        legend:{
            position: 'bottom',
            height: 50
        },
        responsive: [
            {
                breakpoint: 1000,
                options: {
                    plotOptions: {
                        bar: {
                            horizontal: true
                        }
                    },
                    title: {
                        style: {
                            fontSize: '12px'
                        }
                    },
                    legend:{
                        position: 'top',
                    }

                },
            }]
    }
}

// RABarChart1 Options:
export const getRAperRAAperDistrictBarChartOptions = () => {
    return {
        colors: ['#558ed5', '#93cddd'],

        // colors: ['#808288', '#046E98'],

        stroke: {
            width: 3,
            colors: ['#fff']
        },
        tooltip: {
            shared: false
        },
        title: {
            text: ['Rechtsanwält*innen pro Anwärter*in' , 'Hauptstadt und Land'],
            align: 'left',
            margin: 20,
            offsetY: 20,
            style: {
                fontSize: '25px'
            }
        },
        chart: {
            fontFamily: "'Open Sans', sans-serif",
            toolbar: {
                tools: {
                    download: false
                }
            }
        },
        dataLabels: {
            style: {
                fontSize: '10px',
            }
        },
        responsive: [
            {
                breakpoint: 1000,
                options: {
                    stroke: {
                        width: 1,
                        colors: ['#fff']
                    },
                    title: {
                        style: {
                            fontSize: '12px'
                        }
                    },
                    dataLabels: {
                        style: {
                            fontSize: '6px',
                            colors: ['#000'],
                        }
                    },
                }
            }]

    }
}


export const getYearPercentageBarChartOptions = (years) => {
    return {
        // colors: ['#025171', '#036186', '#046E98', '#84A0B7', '#E73729'],
        // colors:  ['#4CAC4E', '#808288', '#5CCFCB', '#02425B', '#B72115'],
        colors: ['#558ed5', '#93cddd', '#c3d69b', '#fac090', '#d99694'],
        // colors: ['#7173a9', '#e8aa78', '#e2918f', '#629ddd', '#a4bf7f'],
        // colors: ['#FFC000', '#B72115', '#02425B', '#4CAC4E', '#FF0000'],
        xaxis: {
            categories: [
                'ausgezeichnet',
                'sehr gut',
                'bestanden',
                'nicht bestanden'
            ],
            axisBorder: {
                show: false
            },
        },
        yaxis: {
            show: false
        },
        plotOptions: {
            bar: {
                horizontal: false,
                dataLabels: {
                    position: 'top',
                    orientation: 'vertical',
                },
                columnWidth: "40%"
            }
        },
        dataLabels: {
            formatter: (val) => {
                return `${val}%`
            },
            style: {
                colors: ['#000'],
            },
            offsetY: 20
        },
        stroke: {
            width: 3,
            colors: ['#fff']
        },
        tooltip: {
            shared: true
            , intersect: false,
            y: {
                formatter: (val) => {
                    return `${val}%`
                }
            },
        },
        title: {
            text: `durchschnittliche Ergebnisse der RAP im Zeitraum ${years[0]} - ${years[years.length - 1]}`,
            align: 'left',
            margin: 20,
            offsetY: 20,
            style: {
                fontSize: '25px'
            }
        },
        chart: {
            fontFamily: "'Open Sans', sans-serif",
            toolbar: {
                tools: {
                    download: false
                }
            }
        },
        legend:{
            position: 'bottom',
            height: 50
        },
        responsive: [
            {
                breakpoint: 1000,
                options: {
                    tooltip: {
                        shared: true,
                        y: {
                            formatter: (val) => {
                                return `${val}%`
                            }
                        },
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                            },
                            columnWidth: "40%"
                        }
                    },
                    legend: {
                        // height: 20,
                        position: 'top',
                        stroke: {
                            width: 0
                        },
                    },
                    dataLabels: {
                        formatter: (val) => {
                            return `${val}%`
                        },
                        offsetX: 25,
                        offsetY: 0,
                        style: {
                            fontSize: '10px'

                        }
                    },
                    title: {
                        style: {
                            fontSize: '12px'
                        }
                    },
                }
            }]
    }
}

export const getYearPercentageLineChartOptions = (years, grade) => {
    return {
        chart: {
            fontFamily: "'Open Sans', sans-serif",
            // height: "450",
            toolbar: {
                tools: {
                    download: false
                }
            },
            events: {
                legendClick: function (chartContext, seriesIndex, config) {
                    if (seriesIndex === 4) {
                        chartContext.updateOptions({
                            dataLabels: {
                                ...config.config.dataLabels,
                                enabled: !config.config.dataLabels.enabled
                            }
                        }, false, true, true)
                    }
                }
            }
        },

        xaxis: {
            categories: years,

            axisBorder: {
                show: false
            },
        },
        yaxis: {
            show: false
        },
        legend: {
            position: 'right',
            offsetY: 200,
            markers: {
                width: 20,
                height: [2, 2, 2, 2, 5],
            },
        },
        stroke: {
            width: [2, 2, 2, 2, 5],
            dashArray: [0, 0, 0, 0, 15],
            lineCap: 'round'
        },
        // colors:
        //     ['#FFC000', '#B72115', '#02425B', '#4CAC4E', '#FF0000'],
        colors: ['#558ed5', '#93cddd', '#c3d69b', '#fac090', '#d99694'],

        tooltip: {
            shared: true,
            y: {
                formatter: (val) => {
                    return `${val}%`
                }
            },
        },
        dataLabels: {
            enabled: true,
            enabledOnSeries: [4],
            formatter: (val) => {
                return `${val}%`
            },
            background: {
                opacity: 1
            }
        },
        markers: {
            size: [0, 0, 0, 0, 5]
        },
        title: {
            text: `Mit „${Object.values(grades)[grade].title}“ beurteilte RAP im Zeitraum ${years[0]} - ${years[years.length - 1]}`,
            align: 'left',
            margin: 20,
            offsetY: 20,
            style: {
                fontSize: '25px'
            }
        },
        responsive: [
            {
                chart: {
                    fontFamily: "'Open Sans', sans-serif",
                    // height: "350"
                },
                breakpoint: 1000,
                options: {
                    legend: {
                        position: "top",
                        offsetY: 0
                    },

                    title: {
                        align: 'left',
                        style: {
                            fontSize: '12px'
                        }
                    },
                },
            }]
    }
}

export const getYearSumLineChartOptions = (years) => {
    return {
        chart: {
            fontFamily: "'Open Sans', sans-serif",
            // height: "450",
            toolbar: {
                tools: {
                    download: false
                }
            }
        },
        xaxis: {
            categories: years,

            axisBorder: {
                show: false
            },
        },
        yaxis: {
            show: false
        },
        legend: {
            position: 'right',
            offsetY: 200,
            markers: {
                width: 20,
                height: [2, 2, 2, 2, 5],
            },
        },
        stroke: {
            width: [2, 2, 2, 2, 5],
            dashArray: [0, 0, 0, 0, 15],
            lineCap: 'round'
        },
        // colors:
        //     ['#FFC000', '#B72115', '#02425B', '#4CAC4E', '#FF0000'],
        colors: ['#558ed5', '#93cddd', '#c3d69b', '#fac090', '#d99694'],

        tooltip: {
            shared: true,
            // y: {
            //     formatter: (val) => {
            //         return `${val}%`
            //     }
            // },
        },
        dataLabels: {
            enabled: true,
            enabledOnSeries: [4],
            // formatter: (val) => {
            //     return `${val}%`
            // },
            background: {
                opacity: 0.6
            }
        },
        markers: {
            size: [0, 0, 0, 0, 5]
        },

        title: {
            text: `RAP (in absoluten Zahlen) im Zeitraum ${years[0]} - ${years[years.length - 1]}`,
            align: 'left',
            margin: 20,
            offsetY: 20,
            style: {
                fontSize: '25px'
            }
        },
        responsive: [
            {
                chart: {
                    fontFamily: "'Open Sans', sans-serif",
                    // height: "350"
                },
                breakpoint: 1000,
                options: {
                    legend: {
                        position: "top",
                        offsetY: 0
                    },

                    title: {
                        text: `RAP pro Jahr nach Sprengeln`,
                        style: {
                            fontSize: '12px'
                        }
                    },
                },
            }]
    }
}

export const getYearSpreadRoundChart = (years) => {
    return {
        chart: {
            fontFamily: "'Open Sans', sans-serif",
            // height: "450",
            toolbar: {
                tools: {
                    download: false
                }
            }
        },
        labels: ['Graz', 'Innsbruck', 'Linz', 'Wien'],
        legend: {
            show: true,
            width: 500,
            offsetY: 120,
            labels: {
                colors: ['#fffff', '#fffff', '#fffff', '#fffff'],
            },
            itemMargin: {
                horizontal: 5,
                vertical: 5
            },
            // markers: {
            //     width: 100,
            //     radius: 0,
            //     offsetX: '70%',
            //     height: 20,
            //     offsetY: 7
            // },
        },
        colors: ['#558ed5', '#93cddd', '#c3d69b', '#fac090', '#d99694'],

        // colors: ['#025171', '#036186', '#046E98', '#84A0B7', '#E73729'],
        title: {
            text: `Verteilung der RAP auf die OLG-Sprengel im Zeitraum ${years[0]} - ${years[years.length - 1]}`,
            align: 'left',
            margin: 20,
            offsetY: 20,
            style: {
                fontSize: '25px'
            }
        },
        responsive: [
            {
                chart: {
                    fontFamily: "'Open Sans', sans-serif",
                    // height: "350"
                },
                breakpoint: 1000,
                options: {
                    chart: {
                        fontFamily: "'Open Sans', sans-serif",
                        offsetX: 0,
                    },
                    legend: {
                        position: "top",
                        offsetY: 0,
                        offsetX: -136
                    },

                    title: {
                        style: {
                            fontSize: '12px'
                        }
                    },
                },
            }]
    }
}

export const getRARoundChart = (years) => {
    return {
        chart: {
            fontFamily: "'Open Sans', sans-serif",
            toolbar: {
                tools: {
                    download: false
                }
            }
        },
        labels: ['Graz', 'Innsbruck', 'Linz', 'Wien'],
        legend: {
            show: true,
            width: 500,
            offsetY: 120,
            labels: {
                colors: ['#fffff', '#fffff', '#fffff', '#fffff'],
            },
            itemMargin: {
                horizontal: 5,
                vertical: 5
            },
            // markers: {
            //     width: 100,
            //     radius: 0,
            //     offsetX: '70%',
            //     height: 20,
            //     offsetY: 7
            // },
        },
        colors: ['#558ed5', '#93cddd', '#c3d69b', '#fac090', '#d99694'],

        // colors: ['#025171', '#036186', '#046E98', '#84A0B7', '#E73729'],
        title: {
            text: `Rechtsanwält*innen: Verteilung nach Sprengel(${years[0]} - ${years[years.length - 1]})`,
            align: 'left',
            margin: 20,
            offsetY: 20,
            style: {
                fontSize: '25px'
            }
        },
        responsive: [
            {
                chart: {
                    fontFamily: "'Open Sans', sans-serif",
                    // height: "350"
                },
                breakpoint: 1000,
                options: {
                    chart: {
                        fontFamily: "'Open Sans', sans-serif",
                        offsetX: 0,
                    },
                    legend: {
                        position: "bottom",
                        offsetY: 0,
                        offsetX: -136
                    },

                    title: {
                        text: `Rechtsanwält*innen: Verteilung nach Sprengel`,
                        style: {
                            fontSize: '12px'
                        }
                    },
                },
            }]
    }
}

export const getRAARoundChart = (years) => {
    return {
        chart: {
            fontFamily: "'Open Sans', sans-serif",
            toolbar: {
                tools: {
                    download: false
                }
            }
        },
        labels: ['Graz', 'Innsbruck', 'Linz', 'Wien'],
        legend: {
            show: true,
            width: 500,
            offsetY: 120,
            labels: {
                colors: ['#fffff', '#fffff', '#fffff', '#fffff'],
            },
            itemMargin: {
                horizontal: 5,
                vertical: 5
            },
            // markers: {
            //     width: 100,
            //     radius: 0,
            //     offsetX: '70%',
            //     height: 20,
            //     offsetY: 7
            // },
        },
        colors: ['#558ed5', '#93cddd', '#c3d69b', '#fac090', '#d99694'],

        // colors: ['#025171', '#036186', '#046E98', '#84A0B7', '#E73729'],
        title: {
            text: 'Anwärter*innen: Verteilung nach Sprengel',
            align: 'left',
            margin: 20,
            offsetY: 20,
            style: {
                fontSize: '25px'
            }
        },
        responsive: [
            {
                chart: {
                    fontFamily: "'Open Sans', sans-serif",
                    // height: "350"
                },
                breakpoint: 1000,
                options: {
                    chart: {
                        fontFamily: "'Open Sans', sans-serif",
                        offsetX: 0,
                    },
                    legend: {
                        position: "bottom",
                        offsetY: 0,
                        offsetX: -136
                    },

                    title: {
                        style: {
                            fontSize: '12px'
                        }
                    },
                },
            }]
    }
}

export const getBarComparisonOptions = (burgenlandComparison, kaerntenComparison) => {
    var col
    if (kaerntenComparison > 0) {
        col = '#000'
    }
    else {
        col = '#FF4560'
    }
    return {
        annotations: {
            points:
                [
                    {
                        x: 'Burgenland',

                        marker: {
                            size: 0,
                        },
                        label: {
                            borderColor: '#FF4560',
                            text: `${burgenlandComparison}%`,
                            offsetY: -30,
                        }
                    },
                    {
                        x: 'Kärnten',

                        marker: {
                            size: 0,
                        },
                        label: {
                            borderColor: col,
                            text: `${kaerntenComparison}%`,
                            offsetY: -30,
                        }
                    },
                    {
                        x: 'Niederösterreich',

                        marker: {
                            size: 0,
                        },
                        label: {
                            borderColor: '#000',
                            text: '+5%',
                            offsetY: -30,
                        }
                    },
                    {
                        x: 'Oberösterreich',

                        marker: {
                            size: 0,
                        },
                        label: {
                            borderColor: '#FF4560',
                            text: '-2%',
                            offsetY: -30,
                        }
                    },
                    {
                        x: 'Salzburg',

                        marker: {
                            size: 0,
                        },
                        label: {
                            borderColor: '#FF4560',
                            text: '-4%',
                            offsetY: -30,
                        }
                    },
                    {
                        x: 'Steiermark',

                        marker: {
                            size: 0,
                        },
                        label: {
                            borderColor: '#000',
                            text: '+18%',
                            offsetY: -30,
                        }
                    },
                    {
                        x: 'Tirol',

                        marker: {
                            size: 0,
                        },
                        label: {
                            borderColor: '#000',
                            text: '+24%',
                            offsetY: -30,
                        }
                    },
                    {
                        x: 'Vorarlberg',

                        marker: {
                            size: 0,
                        },
                        label: {
                            borderColor: '#FF4560',
                            text: '-13%',
                            offsetY: -30,
                        }
                    },
                    {
                        x: 'Wien',

                        marker: {
                            size: 0,
                        },
                        label: {
                            borderColor: '#000',
                            text: '+29%',
                            offsetY: 30,
                        }
                    },
                ]
        }
        ,
        colors: ['#558ed5', '#93cddd', '#c3d69b', '#fac090', '#d99694'],

        // colors: ['#808288', '#5CCFCB', '#4CAC4E', '#046E98'],
        dataLabels: {
            style: {
                colors: ['#000'],
                fontSize: 10
            },

            offsetY: 10
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    position: 'top',
                    orientation: 'vertical'
                }
            }
        },
        chart: {
            fontFamily: "'Open Sans', sans-serif",
            toolbar: {
                tools: {
                    download: false
                }
            },
        },
        tooltip: {
            shared: true
            , intersect: false,
        },
        stroke: {
            width: 1,
            colors: ['#fff']
        },
        title: {
            text: ['Anwärter*innen pro Bundesland', '(Vergleich 2010/2020)'],
            align: 'left',
            margin: 20,
            offsetY: 20,
            style: {
                fontSize: '25px'
            }
        },
        legend: {
            onItemClick: {
                toggleDataSeries: false
            },
        },
        responsive: [
            {
                breakpoint: 1000,
                options: {
                    annotations:{points:
                        []},
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                            },
                            columnWidth: "40%"
                        }
                    },
                    dataLabels: {
                        offsetX: 25,
                        offsetY: 0,
                        style: {
                            fontSize: 7
                        }
                    },
                    title: {
                        style: {
                            fontSize: '12px'
                        }
                    },

                }
            }]
    }
}

export const getBarComparisonRAperRAAOptions = () => {
    return {
        colors: ['#558ed5', '#93cddd', '#c3d69b', '#fac090'],

        // colors: ['#808288', '#5CCFCB', '#4CAC4E', '#046E98'],
        dataLabels: {
            style: {
                colors: ['#000'],
                fontSize: 10
            },

            offsetY: 10
        },
        plotOptions: {
            bar: {
                dataLabels: {
                    position: 'top',
                    orientation: 'vertical'
                }
            }
        },
        chart: {
            fontFamily: "'Open Sans', sans-serif",
            toolbar: {
                tools: {
                    download: false
                }
            }
        },
        tooltip: {
            shared: true
            , intersect: false,
        },
        stroke: {
            width: 1,
            colors: ['#fff']
        },
        title: {
            text:['Anwärter/in pro Rechtsanwältin/-anwalt','(2010-2020)'],
            align: 'left',
            margin: 20,
            offsetY: 20,
            style: {
                fontSize: '25px'
            }
        },
        legend: {
            onItemClick: {
                toggleDataSeries: false
            },
        },
        responsive: [
            {
                breakpoint: 1000,
                options: {

                    plotOptions: {
                        bar: {
                            horizontal: true,
                            dataLabels: {
                                position: 'top',
                                orientation: 'horizontal',
                            },
                            columnWidth: "40%"
                        }
                    },
                    dataLabels: {
                        offsetX: 25,
                        offsetY: 0,
                        style: {
                            fontSize: 7
                        }
                    },
                    title: {
                        style: {
                            fontSize: '12px'
                        }
                    },
                }
            }]
    }
}